import { render, staticRenderFns } from "./UploadDocumentForm.vue?vue&type=template&id=3c292e3e"
import script from "./UploadDocumentForm.vue?vue&type=script&lang=ts"
export * from "./UploadDocumentForm.vue?vue&type=script&lang=ts"
import style0 from "./UploadDocumentForm.vue?vue&type=style&index=0&id=3c292e3e&prod&lang=scss&module=true"
import style1 from "./UploadDocumentForm.vue?vue&type=style&index=1&id=3c292e3e&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports